import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Workflow } from "lucide-react";
import TopNav from "@/components/TopNav";
import { FlowDocumentViewer } from "@/components/FlowDocumentViewer";
import { getSession, chartUrl, chartPdfUrl } from "@/lib/api";

export default function FlowDocument() {
  const { sid } = useParams();
  const [company, setCompany] = useState("");

  useEffect(() => {
    getSession(sid).then((d) => setCompany(d?.session?.company || "")).catch(() => {});
  }, [sid]);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="flow-document-page">
      <TopNav />
      <main className="mx-auto max-w-6xl px-6 py-12 lg:px-10">
        <Link
          to={`/informe/${sid}`}
          className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-slate-500 hover:text-slate-900"
          data-testid="flow-back-to-report"
        >
          <ArrowLeft className="h-3 w-3" /> Informe ejecutivo
        </Link>
        <p className="eyebrow mt-6 flex items-center gap-1.5 text-accent-blue">
          <Workflow className="h-3 w-3" /> Documento final · flujo de actividades
        </p>
        <h1 className="mt-3 font-display text-4xl font-medium sm:text-5xl">{company || "Flujo de actividades"}</h1>
        <p className="mt-3 max-w-2xl text-sm text-slate-600">
          Recorrido de cada cargo, actividad por actividad, con los sistemas que intervienen en cada paso.
        </p>
        <div className="mt-8">
          <FlowDocumentViewer pngUrl={chartUrl(sid)} pdfUrl={chartPdfUrl(sid)} />
        </div>
      </main>
    </div>
  );
}
